<div class="row">
    <div class="col-sm-4">
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Name</label>
                <input class="form-control" type="text" [(ngModel)]="carrier.name" [ngClass]="carrier.name==''?'border-danger':''" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">MC #</label>
                <input class="form-control" type="text" [(ngModel)]="carrier.mcNumber" [ngClass]="carrier.mcNumber==''?'border-danger':''" required />
            </div>
            <div class="col-sm-3">
                <label class="font-weight-bold">DOT #</label>
                <input class="form-control" type="text" [(ngModel)]="carrier.dotNumber" />
            </div>
            <div class="col-sm-3">
                <label class="font-weight-bold">SCAC</label>
                <input class="form-control" type="text" [(ngModel)]="carrier.scacCode" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Address 1</label>
                <input class="form-control" type="text" [(ngModel)]="carrier.address1" maxlength="100" [ngClass]="carrier.address1==''?'border-danger':''" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Address 2</label>
                <input class="form-control" type="text" [(ngModel)]="carrier.address2" maxlength="100" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold" [ngClass]="carrier.cityID>0?'':'text-danger'">City</label>
                <city-state-zip-dropdown [parentForm]="formGroup"
                                         [ctrlName]="'cityCtrl'"
                                         [placeholder]="'Select a City'"
                                         [cityID]="carrier.cityID"
                                         (citySelected)="citySTChanged($event)"
                                         [defaultCity]="defaultCarrierCity"
                                         [isRequired]="true"></city-state-zip-dropdown>
            </div>
        </div>
        <div class="row" *ngIf="searchCarrierRMIS.rmisStatus == 'Attached'">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">RMIS Attached</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <kendo-datepicker name="attachedDate" [(ngModel)]="searchCarrierRMIS.attachedDate"
                                          [format]="'MM/dd/yy'" [disabled]="true">
                        </kendo-datepicker>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-primary" (click)="rmisAttachOrDetachCarrier('Detach')">Detach</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="searchCarrierRMIS.rmisStatus == 'Detached'">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">RMIS Detached</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <kendo-datepicker name="detachedDate" [(ngModel)]="searchCarrierRMIS.detachedDate"
                                          [format]="'MM/dd/yy'" [disabled]="true">
                        </kendo-datepicker>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-primary" (click)="rmisAttachOrDetachCarrier('Attach')">Reattach</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="searchCarrierRMIS.rmisStatus == 'Potential Carrier'">
            <div class="col-sm-3">
                <input type="checkbox" [(ngModel)]="searchCarrierRMIS.existsInRMIS" [checked]="searchCarrierRMIS.existsInRMIS" /> In RMIS
            </div>
            <div class="col-sm-4">
                <input type="checkbox" [(ngModel)]="searchCarrierRMIS.dotCompliant" [checked]="searchCarrierRMIS.dotCompliant" /> DOT Certified
            </div>
            <div class="col">
                <input type="checkbox" [(ngModel)]="searchCarrierRMIS.insuranceCompliant" [checked]="searchCarrierRMIS.insuranceCompliant" /> Insurance Compliant
            </div>
        </div>
    </div>
    <div class="col-sm-4">
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Macropoint</label>
                <!--<mat-select placeholder="" class="form-control" [(ngModel)]="carrier.macropointLocationProvider">
                <mat-option *ngFor="let provider of macropointLocationProviders" [value]="provider.macropointLocationProviderId">
                    {{provider.device}}
                </mat-option>
            </mat-select>-->
                <select name="macropointLocationProviderId" [(ngModel)]="carrier.macropointLocationProviderId" class="form-select">
                    <option *ngFor="let provider of macropointLocationProviders" value="{{provider.macropointLocationProviderId}}">{{provider.device}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Truck count</label>
                <input type="number" class="form-control" [(ngModel)]="carrier.trucks" step="1" min="0" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <input type="checkbox" [(ngModel)]="carrier.retired" [checked]="carrier.retired" /> Retired
            </div>
        </div>
        <div class="row">
            <div class="col">
                <input type="checkbox" [(ngModel)]="carrier.excludedFromAutotenderEmail" [checked]="carrier.excludedFromAutotenderEmail" /> Exclude Email
            </div>
        </div>
        <div class="row">
            <div class="col">
                <input type="checkbox" [(ngModel)]="carrier.excludeRequiredDataBeforeVerifyLoad" [checked]="carrier.excludeRequiredDataBeforeVerifyLoad" /> Exclude Verify
            </div>
        </div>
    </div>
    <div class="col">
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Notes</label>
                <!--<textarea name="notes" class="form-control" [(ngModel)]="carrier.notes"></textarea>-->
                <kendo-textarea style="width:100%" id="notes"
                                resizable="auto"
                                [(ngModel)]="carrier.notes"
                                [value]="carrier.notes">
                </kendo-textarea>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col text-end">
        <button class="btn btn-primary m-1" (click)="saveCarrier(false)" [disabled]="isLoading||!isValid()">Save</button>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': isLoading}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
